// @flow
import { DEFAULT_ARCHIVE_STATUSES, DEFAULT_LIVE_STATUSES } from '../../utils/searchUtils';
import api from '../api/search';
import { buildSearchQuery } from '../../utils/searchQuery';
import { createSelector } from 'reselect';
import { getAuthToken } from './user';
import { getDeployment } from './config';
import type { GlobalState } from '../rootReducer';

/* Action Types */
export const LOAD_CATALOG_FEATURED_FAIL = 'la/domain/catalogFeatured/LOAD_FAIL';
export const LOAD_CATALOG_FEATURED_REQUEST = 'la/domain/catalogFeatured/LOAD_REQUEST';
export const LOAD_CATALOG_FEATURED_SUCCESS = 'la/domain/catalogFeatured/LOAD_SUCCESS';

/* reducer */
const DEFAULT_STATE = {
    featuredIdsByCatalog: {},
};

export type State = {|
    ...typeof DEFAULT_STATE,
|};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case LOAD_CATALOG_FEATURED_SUCCESS:
            return {
                ...state,
                featuredIdsByCatalog: {
                    ...state.featuredIdsByCatalog,
                    [action.payload.catalogId]: action.payload.featuredLots,
                },
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.catalogFeatured || DEFAULT_STATE;

export const featuredIdsByCatalogSelector = createSelector(stateSelector, state => state.featuredIdsByCatalog);

export const catalogHasFeatured = (state: any, catlogId: number) => {
    let featuredByCat = featuredIdsByCatalogSelector(state);
    if (featuredByCat[catlogId]) return featuredByCat[catlogId].length > 0;
    return false;
};

const shouldFetchCatalogFeatured = (state, catlogId) => {
    let featuredByCat = featuredIdsByCatalogSelector(state);
    if (featuredByCat[catlogId]) return featuredByCat[catlogId].length === 0;
    return true;
};

/* ACTION CREATORS */
export const fetchCatalogFeaturedIfNeeded = (catalogId: number) => async (dispatch: Function, getState: Function) => {
    const state = getState();
    if (shouldFetchCatalogFeatured(state, catalogId)) {
        try {
            // 2000 should be whatever the max number of promoted lots one catalog can have
            const searchQuery = buildSearchQuery({
                searchPageSize: 2000,
            });
            searchQuery.catalogId = Number(catalogId);
            searchQuery.options.status = [...DEFAULT_LIVE_STATUSES, ...DEFAULT_ARCHIVE_STATUSES];
            const deployment = getDeployment(state);
            const authToken = getAuthToken(state);

            dispatch({
                meta: catalogId,
                payload: catalogId,
                type: LOAD_CATALOG_FEATURED_REQUEST,
            });
            const response = await api.fetchPromotedSearchResults({ authToken, deployment, searchQuery });
            dispatch({
                meta: catalogId,
                payload: { catalogId, featuredLots: response.itemIDs },
                type: LOAD_CATALOG_FEATURED_SUCCESS,
            });
        } catch (error) {
            dispatch({
                error: true,
                meta: catalogId,
                payload: error,
                type: LOAD_CATALOG_FEATURED_FAIL,
            });
        }
    } else {
        return Promise.resolve();
    }
};
